export default "__VITE_ASSET__DixKMSAL__"